import type { User } from "@supabase/supabase-js";

export function userOwnsCustomerOrder(
  user: User | null,
  order: { user_id: string | null; customer_email: string },
): boolean {
  if (!user?.email) return false;
  if (order.user_id && order.user_id === user.id) return true;
  return order.customer_email.trim().toLowerCase() === user.email.trim().toLowerCase();
}
